"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var icons_1 = __importDefault(require("../../../assets/icons"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var Icon_1 = require("../Icon/Icon");
var Typography_1 = require("../Typography/Typography");
var SelectButton_style_1 = __importDefault(require("./SelectButton.style"));
/**
 * SelectButton atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-buttons-selectbutton--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/SelectButton Source}
 */
exports.SelectButton = (0, react_1.forwardRef)(function (_a, ref) {
    var className = _a.className, icon = _a.icon, label = _a.label, width = _a.width, isDisabled = _a.isDisabled, isSelected = _a.isSelected, unselectable = _a.unselectable, onChange = _a.onChange, other = __rest(_a, ["className", "icon", "label", "width", "isDisabled", "isSelected", "unselectable", "onChange"]);
    var classes = (0, SelectButton_style_1.default)({ width: width });
    var arePointerEventsIgnored = (isSelected && !unselectable) || isDisabled;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)(classes.root, !arePointerEventsIgnored && classes.rootWithHover, arePointerEventsIgnored && classes.cursorDefault, !icon && classes.rootNoIcon, isSelected && classes.selected, isDisabled && classes.disabled, className), onClick: arePointerEventsIgnored ? undefined : function () { return onChange === null || onChange === void 0 ? void 0 : onChange(!isSelected); }, ref: ref, role: 'button' }, other, { children: [icon && (0, jsx_runtime_1.jsx)(Icon_1.Icon, { className: 'icon', iconPath: icon, color: theme_1.default.textColors.primary, size: 24 }), (0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ variant: 'headline3' }, { children: label })), isSelected && ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { className: 'checkMark', iconPath: icons_1.default.checkMark, color: theme_1.default.colors.primary, size: 24 }))] })));
});
